export default __webpack_public_path__ + "static/flip-44a9a4eb189ec622f2afe386e69b00b0.mp3";